import { gql } from '@apollo/client'

export const GET_SLUG_SUGGESTION = gql`
    query GetSlugSuggestion(
        $guid: String
        $title: NonEmptyString!
        $urlSlug: String
    ) {
        entitySlugSuggestion(guid: $guid, title: $title, urlSlug: $urlSlug) {
            available
            suggestion
        }
    }
`
